import script from "./SingleProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleProductTable.vue?vue&type=script&setup=true&lang=js"

import "./SingleProductTable.vue?vue&type=style&index=0&id=1bed0eb8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bed0eb8"]])

export default __exports__